/**
 * Konto-Menue oben rechts. Ersetzt den frueheren Abmelden-Knopf: dort sass
 * eine Aktion, hier sitzt jetzt die Person — mit Namen, Adresse, dem Weg zu
 * den eigenen Einstellungen und dem Abmelden ganz unten, abgesetzt.
 */
import { LogOut, UserRound } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { InitialsAvatar } from '@/components/InitialsAvatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { authClient } from '@/lib/auth-client';
import { toastError } from '@/lib/errors';
import { useSession } from '@/lib/session';

export function AccountMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, clear } = useSession();

  if (!user) return null;

  async function signOut() {
    try {
      await authClient.signOut();
    } catch (error) {
      toastError(error, t);
    } finally {
      // Auch nach einem Fehlschlag lokal aufraeumen: der Mensch wollte raus.
      clear();
      void navigate('/login', { replace: true });
    }
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        aria-label={t('account.menu_label')}
      >
        <InitialsAvatar name={user.name} decorative />
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        {/* Kein Menuepunkt, sondern die Antwort auf „als wem bin ich hier
            eigentlich angemeldet" — bei mehreren Mandanten der haeufigste
            Grund, das Menue ueberhaupt zu oeffnen. */}
        <div className="px-2 py-1.5">
          <p className="text-sm font-medium">{user.name}</p>
          <p className="truncate text-xs text-muted-foreground">{user.email}</p>
        </div>

        <DropdownMenuSeparator />

        <DropdownMenuItem onSelect={() => void navigate('/account')}>
          <UserRound aria-hidden="true" />
          {t('account.title')}
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem onSelect={() => void signOut()}>
          <LogOut aria-hidden="true" />
          {t('nav.logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
